var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative",attrs:{"id":"page-placement-settings"}},[_c('iframe-v4',{attrs:{"src":_vm.url,"height":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }